module.exports = __webpack_public_path__ + "static/media/logo.54b7a57c.png";